import { combineReducers } from 'redux';

import staticInitializable from '../utils/static-initializable';
import { initializeCreatives } from './actions';
import creativesById from './creatives-by-id';

export default combineReducers({
  context: staticInitializable('context', initializeCreatives),
  creativesById,
});
